import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { addIntlProps, addProps } from 'utils/recompose';
import messages from './messages';
import { inCartQuantityForSubsection } from 'reducers/inCartTemplates/selectors';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({
  inCartQuantityForSubsection,
});

export const quantityLabel = ({ inCartQuantityForSubsection, unit, units }) =>
  inCartQuantityForSubsection > 1
    ? `${inCartQuantityForSubsection} ${units}`
    : `${inCartQuantityForSubsection} ${unit}`;

export default compose(
  connect(mapStateToProps),
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['unit', 'units'],
  }),
  addProps({ quantityLabel }),
);
